import React from 'react'
import { Drawer } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { NAV_TYPE_SIDE } from 'constants/ThemeConstant'
import { Scrollbars } from 'react-custom-scrollbars-2'
import MenuContent from './MenuContent'
import { onMobileNavToggle } from 'store/slices/themeSlice'
import Flex from 'components/shared-components/Flex'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { LogoSVG } from 'assets/svg/icon'
import styled from '@emotion/styled'

const LogoWrapper = styled('div')`
  padding: 0.5em 1.5em;
`

export const MobileNav = ({ routeInfo, hideGroupTitle }) => {
  const dispatch = useDispatch()
  const currentTheme = useSelector((state) => state.theme.currentTheme)
  const mobileNav = useSelector((state) => state.theme.mobileNav)

  const menuContentprops = { routeInfo, hideGroupTitle }

  const onClose = () => {
    dispatch(onMobileNavToggle(false))
  }

  return (
    <Drawer
      placement='left'
      closable={false}
      onClose={onClose}
      open={mobileNav}
      styles={{ body: { padding: '5px 0' } }}
      width={256}
    >
      <Flex flexDirection='column' className='h-100' gap={16}>
        <Flex justifyContent='space-between' alignItems='center'>
          <LogoWrapper>
            <LogoSVG
              color={currentTheme === 'light' ? undefined : '#fff'}
              width={100}
              height={46}
              showCompanyName
              preserveAspectRatio='xMinYMin slice'
            />
          </LogoWrapper>

          <div className='px-3' onClick={() => onClose()}>
            <ArrowLeftOutlined />
          </div>
        </Flex>

        <div className='h-100'>
          <Scrollbars autoHide>
            <MenuContent type={NAV_TYPE_SIDE} {...menuContentprops} />
          </Scrollbars>
        </div>
      </Flex>
    </Drawer>
  )
}

export default MobileNav
